import React, {Component} from 'react';
import { getCurrentUserId, getJwt } from '../../../services/authService';
import http from '../../../services/httpService';
import Header from '../Header'
import Form from '../../common/Form'
import Joi from "joi-browser";
import {Link} from 'react-router-dom'
// import ReactGA from "react-ga";

class RssFeedSource extends Form {
    constructor(props) {
        super(props);

        this.state = {
            data:
                {
                    rss: '',
                    autopush_enabled: ''
                },
            spinnerActive: false,
            errors: {},
            feedData: {},
            enableAutoPush: true
        };
    }

    schema = {
        rss: Joi.string().required().label("Website")
    };

    async componentDidMount() {

       // ReactGA.pageview(window.location.pathname + window.location.search);
        let feed_id = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        if (feed_id) {
            try {
                this.setState({spinnerActive: true});
                const result = await http.get('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                // console.log('Sta je u rezultatu: ', result)
                this.props.updateSources(result.data.data);
                //const resultLimited = result.data.data.rss.substring(0,40)+"...";
                if (result) {
                    this.setState({
                        data: {
                            rss: result.data.data.rss,
                            autopush_enabled: result.data.data.autopush_enabled
                        },
                        feedData: result.data.data,
                        enableAutoPush: result.data.data.autopush_enabled ? true : false
                    })
                }
                this.setState({spinnerActive: false})
            } catch (ex) {
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
            }
        }
    }

    doSubmit = async () => {
        const feed_id = localStorage.getItem('feed_id');
        const navigateBackTo = localStorage.getItem("navigateBackTo");
        // console.log('Ovo je resultccc: ',feed_id)
        const user_id = getCurrentUserId();
        if (user_id){
            try {
                this.setState({ spinnerActive: true });
                // let resultccc = await http.get('this_rss/' + feed_id, { headers: { authorization: getJwt() } });
                let result = await http.patch('api/feed/' + feed_id, { autopush_enabled: this.state.enableAutoPush ? 1 : 0 }, { headers: { authorization: getJwt() } });
                // const userResult = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
                const userResult = await http.get('api/user_info', {headers: {authorization: getJwt()}});

                await this.props.updateUser(userResult.data.data)
            } catch(ex) {
                if(ex.response && (ex.response.status === 400 || ex.response.status === 422)){
                    const errors_obj = this.state.errors;
                    let errors = { ...errors_obj };
                    errors = ex.response.data.errors;
                    this.setState({ errors });
                }
            }
        }
        this.setState({spinnerActive: false});
        navigateBackTo === '/content-automation' ?
            this.props.history.push('content-automation')
            :
            this.props.history.push('distribution-platforms')
    };

    patchAutoPush = async () => {
        try {
            const feed_id = localStorage.getItem('feed_id');
            let result = await http.patch('api/feed/' + feed_id, {autopush_enabled: this.state.enableAutoPush ? 1 : 0}, {headers: {authorization: getJwt()}});
        } catch (ex) {
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors = ex.response.data.errors;
                this.setState({errors});
            }
        }

    }

    toggleAutoPush = async () => {
        await this.setState({
            data: {
                ...this.state.data,
                autopush_enabled: this.state.data.autopush_enabled === 1 ? 0 : 1
            },
            enableAutoPush: !this.state.enableAutoPush,
            feedData: {
                ...this.state.feedData,
                autopush_enabled: this.state.data.autopush_enabled === 1 ? 0 : 1
            }
        })
        //  console.log('Aaaaaaaa: ', this.state.data)
    }

    handleCancel = async () => {
        const id = localStorage.getItem("feed_id");
        const navigateBackTo = localStorage.getItem("navigateBackTo");
        if (navigateBackTo) {
            this.props.history.push(navigateBackTo)
            localStorage.removeItem('navigateBackTo')
            localStorage.removeItem('removeSuccessMessage')
        } else {
            try {
                const result = await http.patch('api/feed/' + id, {rss: ''}, {headers: {authorization: getJwt()}});
                if (!result.data.rss) {
                    this.props.history.push('distribution-platforms')
                }
            } catch (ex) {
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
            }
        }
    }

    render() {
        const removeSuccessMessage = localStorage.removeSuccessMessage || '';
        const navigateBackTo = localStorage.getItem("navigateBackTo");
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Set Up Content Source</h1>
                        {removeSuccessMessage ? null :
                            <p className='text-bold m-m-b green-field'>Awesome! We've found this RSS feed for<br/>
                                the URL you've provided.</p>
                        }
                        <div className={"non-editable-input"}>
                            <p>{this.state.data.rss}</p>
                            <p className={"edit-button"}
                               onClick={() => this.props.history.push('manual-feed-source')}>Edit</p>
                        </div>
                        <div className="details-trigger right">
                            <label className="switch">
                                <input type="checkbox" checked={!this.state.enableAutoPush}
                                       onClick={this.toggleAutoPush}/>
                                <span className="slider round"></span>
                            </label>
                            { /* checked must be oposite of state to work properly */}
                            <p>Enable Autopush</p>
                        </div>
                        <p className='m-m-b'>Autopush saves you time by automatically broadcasting<br/>
                            all the newly published content on your website to <br/>
                            your Web Push subscribers.</p>
                        {localStorage.navigateBackTo === '/workspace-settings' ?

                                <button className="btn-action" onClick={() => {
                                    this.patchAutoPush();
                                    this.props.updateSources(this.state.feedData)
                                    this.props.history.push(localStorage.navigateBackTo)
                                    localStorage.removeItem('navigateBackTo')
                                    localStorage.removeItem('removeSuccessMessage')
                                }}>Save</button>

                            :

                            (this.state.spinnerActive === true ? <button disabled className="btn-action"
                                                                         onClick={() => this.doSubmit()}>{ navigateBackTo === '/content-automation' ? 'Done' : 'Next' }
                                <i className='fa fa-spin fa-spinner'></i></button> :
                                <button className="btn-action" onClick={() => this.doSubmit()}>
                                    { navigateBackTo === '/content-automation' ? 'Done' : 'Next' }
                                </button>
                            )

                        }

                        {/*{ this.renderButton("Next") }*/}
                        <div className='panel-message text-center'>
                            <Link to="#" onClick={() => this.handleCancel()}>Cancel</Link>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default RssFeedSource;